export default __webpack_public_path__ + "static/media/4l.5f51db4f.svg";